
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"highlight-stroke",attrs:{"d":"M24.3 20.3L13.5 3.4c-.2-.3-.6-.6-1-.6s-.8.2-1 .6L.7 20.3c-.2.4-.3.8 0 1.2.2.4.6.6 1.1.6h21.7c.4 0 .8-.2 1.1-.6 0-.4 0-.9-.3-1.2h0zm-11.8-14l3.2 5h-3.2l-2.4 2.4-1.4-1.4 3.8-6z","fill":"none","stroke":"#fff"}})])
          )
        }
      }
    